module.exports = __webpack_public_path__ + "static/media/emergencia.b174dee0.webp";